export default __webpack_public_path__ + "static/media/SwiftPlaygrounds.2d697dd1.webp";